import { useNavigate } from 'react-router-dom';

export default function Changelog() {
  const navigate = useNavigate();

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: 'var(--bg-primary)',
      padding: '1rem 0 2rem 0'
    }}>
      {/* Header */}
      <div style={{
        position: 'sticky',
        top: 0,
        backgroundColor: 'var(--bg-primary)',
        borderBottom: '1px solid var(--border-color)',
        padding: '1rem',
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        gap: '1rem'
      }}>
        <button
          onClick={() => navigate(-1)}
          className="btn"
          style={{
            background: 'none',
            border: 'none',
            fontSize: '1.5rem',
            cursor: 'pointer',
            padding: '0.5rem',
            display: 'flex',
            alignItems: 'center',
            color: 'var(--text-primary)'
          }}
        >
          ←
        </button>
        <h1 style={{ fontSize: '1.5rem', fontWeight: '700', color: 'var(--text-primary)', margin: 0 }}>
          Changelog
        </h1>
      </div>

      {/* Content */}
      <div style={{ 
        maxWidth: '800px', 
        margin: '0 auto', 
        padding: '2rem 1rem',
      }}>
      {/* Version 1.1.0 */}
        <div style={{
          backgroundColor: 'var(--bg-secondary)',
          borderRadius: '0.75rem',
          padding: '1.5rem',
          marginBottom: '1.5rem',
          border: '2px solid var(--primary)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginBottom: '1rem'
          }}>
            <span style={{
              backgroundColor: 'var(--primary)',
              color: 'white',
              padding: '0.25rem 0.75rem',
              borderRadius: '1rem',
              fontSize: '0.875rem',
              fontWeight: '600'
            }}>
              v1.1.0
            </span>
            <span style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
              29. März 2026
            </span>
            <span style={{
              backgroundColor: 'var(--primary)',
              color: 'white',
              padding: '0.15rem 0.6rem',
              borderRadius: '1rem',
              fontSize: '0.75rem',
              fontWeight: '600',
              opacity: 0.85
            }}>
              Aktuell
            </span>
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ color: 'var(--success)', fontSize: '1rem', fontWeight: '600', marginBottom: '0.75rem' }}>
              Neu
            </h3>
            <ul style={{ margin: 0, paddingLeft: '1.5rem', color: 'var(--text-primary)', lineHeight: '1.8' }}>
              <li><strong>In-App-Chat:</strong> Direktnachrichten pro Liste – in Echtzeit, mit Lesebestätigungen (✓✓) und Push-Benachrichtigungen für abwesende Mitglieder</li>
              <li><strong>Vorlagen:</strong> Jede Liste als Vorlage speichern und beim Erstellen neuer Listen wiederverwenden</li>
              <li><strong>Ungelesen-Badges:</strong> Grüner Punkt für neue Chat-Nachrichten, „X neu"-Pill für neue Einträge – live aktualisiert ohne Neuladen</li>
            </ul>
          </div>
        </div>

        {/* Version 1.0.8 */}
        <div style={{
          backgroundColor: 'var(--bg-secondary)',
          borderRadius: '0.75rem',
          padding: '1.5rem',
          marginBottom: '1.5rem',
          border: '1px solid var(--border-color)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginBottom: '1rem'
          }}>
            <span style={{
              backgroundColor: 'var(--primary)',
              color: 'white',
              padding: '0.25rem 0.75rem',
              borderRadius: '1rem',
              fontSize: '0.875rem',
              fontWeight: '600'
            }}>
              v1.0.8
            </span>
            <span style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
              25. März 2026
            </span>
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ color: 'var(--success)', fontSize: '1rem', fontWeight: '600', marginBottom: '0.75rem' }}>
              Neu
            </h3>
            <ul style={{ margin: 0, paddingLeft: '1.5rem', color: 'var(--text-primary)', lineHeight: '1.8' }}>
              <li><strong>Fälligkeitsdatum beim Erstellen:</strong> Direkt beim Anlegen einer Aufgabe ein Datum setzen</li>
              <li><strong>Vorab-Erinnerungen:</strong> Push-Benachrichtigung wahlweise 15 Min, 30 Min, 1 Std, 2 Std oder 1 Tag vor Fälligkeit</li>
              <li><strong>Offline-Sync verbessert:</strong> Abhaken, Bearbeiten und Löschen werden jetzt auch offline gespeichert und beim Reconnect synchronisiert</li>
            </ul>
          </div>

          <div>
            <h3 style={{ color: 'var(--warning)', fontSize: '1rem', fontWeight: '600', marginBottom: '0.75rem' }}>
              Verbessert
            </h3>
            <ul style={{ margin: 0, paddingLeft: '1.5rem', color: 'var(--text-primary)', lineHeight: '1.8' }}>
              <li>Dark Mode: Neues grünes Farbschema statt Lila</li>
              <li>Einladungslinks enthalten jetzt korrekt die Domain meinelisten.app</li>
            </ul>
          </div>
        </div>

        {/* Version 1.0.7 */}
        <div style={{
          backgroundColor: 'var(--bg-secondary)',
          borderRadius: '0.75rem',
          padding: '1.5rem',
          marginBottom: '1.5rem',
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginBottom: '1rem'
          }}>
            <span style={{
              backgroundColor: 'var(--primary)',
              color: 'white',
              padding: '0.25rem 0.75rem',
              borderRadius: '1rem',
              fontSize: '0.875rem',
              fontWeight: '600'
            }}>
              v1.0.7
            </span>
            <span style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
              26. Februar 2026
            </span>
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ color: 'var(--success)', fontSize: '1rem', fontWeight: '600', marginBottom: '0.75rem' }}>
              Neu
            </h3>
            <ul style={{ margin: 0, paddingLeft: '1.5rem', color: 'var(--text-primary)', lineHeight: '1.8' }}>
              <li><strong>Google Sign-In:</strong> Anmeldung und Registrierung per Google-Konto
                <ul style={{ marginTop: '0.5rem', paddingLeft: '1.5rem' }}>
                  <li>Ein-Klick-Login ohne Passwort – im Browser und in der Android-App</li>
                  <li>Automatische Verknüpfung mit bestehendem E-Mail-Konto</li>
                </ul>
              </li>
            </ul>
          </div>

          <div>
            <h3 style={{ color: 'var(--warning)', fontSize: '1rem', fontWeight: '600', marginBottom: '0.75rem' }}>
              Verbessert
            </h3>
            <ul style={{ margin: 0, paddingLeft: '1.5rem', color: 'var(--text-primary)', lineHeight: '1.8' }}>
              <li>Landingpage: Echter Google Play Store Link eingebunden</li>
            </ul>
          </div>
        </div>

        {/* Version 1.0.6 */}
        <div style={{
          backgroundColor: 'var(--bg-secondary)',
          borderRadius: '0.75rem',
          padding: '1.5rem',
          marginBottom: '1.5rem',
          border: '1px solid var(--border-color)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginBottom: '1rem'
          }}>
            <span style={{
              backgroundColor: 'var(--primary)',
              color: 'white',
              padding: '0.25rem 0.75rem',
              borderRadius: '1rem',
              fontSize: '0.875rem',
              fontWeight: '600'
            }}>
              v1.0.6
            </span>
            <span style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
              20. Februar 2026
            </span>
          </div>

          {/* New Features */}
          <div style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ 
              color: 'var(--success)', 
              fontSize: '1rem', 
              fontWeight: '600', 
              marginBottom: '0.75rem'
            }}>
              Neu
            </h3>
            <ul style={{ 
              margin: 0, 
              paddingLeft: '1.5rem',
              color: 'var(--text-primary)',
              lineHeight: '1.8'
            }}>
              <li><strong>Erledigte Artikel auf einmal löschen:</strong> Neuer "Alle löschen"-Button neben der "Erledigt"-Überschrift
                <ul style={{ marginTop: '0.5rem', paddingLeft: '1.5rem' }}>
                  <li>Alle abgehakten Artikel/Aufgaben mit einem Klick entfernen</li>
                  <li>Bestätigungsdialog vor dem Löschen</li>
                  <li>Funktioniert für Shopping-Listen und TODO-Listen</li>
                </ul>
              </li>
            </ul>
          </div>

          {/* Fixes */}
          <div>
            <h3 style={{ 
              color: 'var(--warning)', 
              fontSize: '1rem', 
              fontWeight: '600', 
              marginBottom: '0.75rem'
            }}>
              Behoben
            </h3>
            <ul style={{ 
              margin: 0, 
              paddingLeft: '1.5rem',
              color: 'var(--text-primary)',
              lineHeight: '1.8'
            }}>
              <li>Bestätigungs-Modal schloss sich nach Bestätigung nicht korrekt</li>
              <li>Deep Links (Einladungslinks) öffneten die App nicht direkt, sondern landeten im Browser</li>
            </ul>
          </div>
        </div>

        {/* Version 1.0.5 */}
        <div style={{
          backgroundColor: 'var(--bg-secondary)',
          borderRadius: '0.75rem',
          padding: '1.5rem',
          marginBottom: '1.5rem',
          border: '1px solid var(--border-color)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginBottom: '1rem'
          }}>
            <span style={{
              backgroundColor: 'var(--primary)',
              color: 'white',
              padding: '0.25rem 0.75rem',
              borderRadius: '1rem',
              fontSize: '0.875rem',
              fontWeight: '600'
            }}>
              v1.0.5
            </span>
            <span style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
              9. Februar 2026
            </span>
          </div>

          {/* New Features */}
          <div style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ 
              color: 'var(--success)', 
              fontSize: '1rem', 
              fontWeight: '600', 
              marginBottom: '0.75rem'
            }}>
              Neu
            </h3>
            <ul style={{ 
              margin: 0, 
              paddingLeft: '1.5rem',
              color: 'var(--text-primary)',
              lineHeight: '1.8'
            }}>
              <li><strong>Supermarkt-geführtes Einkaufen:</strong> Einkaufslisten nach Supermarkt-Zonen durchgehen
                <ul style={{ marginTop: '0.5rem', paddingLeft: '1.5rem' }}>
                  <li>Supermarkt-Vorlagen mit individuellen Zonen erstellen</li>
                  <li>Listen einem Supermarkt zuweisen für optimalen Einkaufsweg</li>
                  <li>Auto-Icon-Generierung aus Zonennamen (z.B. "Kühlregal" → ❄️)</li>
                  <li>Kategorie-Indikatoren (🏪) zeigen verfügbare Kategorien im Supermarkt</li>
                </ul>
              </li>
              <li><strong>Nicht verfügbare Items:</strong> Doppelklick zum schnellen Markieren ausverkaufter Artikel
                <ul style={{ marginTop: '0.5rem', paddingLeft: '1.5rem' }}>
                  <li>Separate "Nicht verfügbar"-Sektion mit 🚫 Icon</li>
                  <li>Echtzeit-Synchronisation über alle Geräte</li>
                </ul>
              </li>
            </ul>
          </div>

          {/* Improvements */}
          <div style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ 
              color: 'var(--info)', 
              fontSize: '1rem', 
              fontWeight: '600', 
              marginBottom: '0.75rem'
            }}>
              Verbessert
            </h3>
            <ul style={{ 
              margin: 0, 
              paddingLeft: '1.5rem',
              color: 'var(--text-primary)',
              lineHeight: '1.8'
            }}>
              <li>Rate Limits deutlich erhöht für flüssigeres Testing</li>
              <li>Verbesserte Drag & Drop UI für Zonen-Sortierung</li>
              <li>Erweiterte Icon-Keywords für mehr deutsche Begriffe</li>
            </ul>
          </div>

          {/* Fixes */}
          <div style={{ marginBottom: '0' }}>
            <h3 style={{ 
              color: 'var(--warning)', 
              fontSize: '1rem', 
              fontWeight: '600', 
              marginBottom: '0.75rem'
            }}>
              Behoben
            </h3>
            <ul style={{ 
              margin: 0, 
              paddingLeft: '1.5rem',
              color: 'var(--text-primary)',
              lineHeight: '1.8'
            }}>
              <li>Doppelte "Nicht verfügbar"-Anzeige in Supermarkt-Ansicht</li>
              <li>Doppelklick-Erkennung durch verzögerte Ausführung verbessert</li>
            </ul>
          </div>
        </div>

        {/* Version 1.0.4 */}
        <div style={{
          backgroundColor: 'var(--bg-secondary)',
          borderRadius: '0.75rem',
          padding: '1.5rem',
          marginBottom: '1.5rem',
          border: '1px solid var(--border-color)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginBottom: '1rem'
          }}>
            <span style={{
              backgroundColor: 'var(--primary)',
              color: 'white',
              padding: '0.25rem 0.75rem',
              borderRadius: '1rem',
              fontSize: '0.875rem',
              fontWeight: '600'
            }}>
              v1.0.4
            </span>
            <span style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
              8. Februar 2026
            </span>
          </div>

          {/* New Features */}
          <div style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ 
              color: 'var(--success)', 
              fontSize: '1rem', 
              fontWeight: '600', 
              marginBottom: '0.75rem'
            }}>
              Neu
            </h3>
            <ul style={{ 
              margin: 0, 
              paddingLeft: '1.5rem',
              color: 'var(--text-primary)',
              lineHeight: '1.8'
            }}>
              <li><strong>In-App-Benachrichtigungen:</strong> Neue Features werden direkt in der App angezeigt</li>
            </ul>
          </div>

          {/* Improvements */}
          <div style={{ marginBottom: '0' }}>
            <h3 style={{ 
              color: 'var(--info)', 
              fontSize: '1rem', 
              fontWeight: '600', 
              marginBottom: '0.75rem'
            }}>
              Verbessert
            </h3>
            <ul style={{ 
              margin: 0, 
              paddingLeft: '1.5rem',
              color: 'var(--text-primary)',
              lineHeight: '1.8'
            }}>
              <li>Statusleiste wird wieder korrekt angezeigt</li>
            </ul>
          </div>
        </div>

        {/* Version 1.0.3 */}
        <div style={{
          backgroundColor: 'var(--bg-secondary)',
          borderRadius: '0.75rem',
          padding: '1.5rem',
          marginBottom: '1.5rem',
          border: '1px solid var(--border-color)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginBottom: '1rem'
          }}>
            <span style={{
              backgroundColor: 'var(--primary)',
              color: 'white',
              padding: '0.25rem 0.75rem',
              borderRadius: '1rem',
              fontSize: '0.875rem',
              fontWeight: '600'
            }}>
              v1.0.3
            </span>
            <span style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
              7. Februar 2026
            </span>
          </div>

          {/* New Features */}
          <div style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ 
              color: 'var(--success)', 
              fontSize: '1rem', 
              fontWeight: '600', 
              marginBottom: '0.75rem'
            }}>
              Neu
            </h3>
            <ul style={{ 
              margin: 0, 
              paddingLeft: '1.5rem',
              color: 'var(--text-primary)',
              lineHeight: '1.8'
            }}>
              <li><strong>Listen-Typen:</strong> Shopping-Listen und TODO-Listen mit angepasster UI</li>
              <li><strong>Smart Kategorie-System</strong> mit automatischer Erkennung:
                <ul style={{ marginTop: '0.5rem', paddingLeft: '1.5rem' }}>
                  <li>11 Kategorien mit modernen Icons (Obst & Gemüse, Milchprodukte, Backwaren, etc.)</li>
                  <li>200+ deutsche Keywords für Auto-Detection</li>
                  <li>System merkt sich deine Kategorie-Zuweisungen</li>
                </ul>
              </li>
              <li><strong>Gruppierte Ansicht:</strong> Items nach Kategorien sortieren (umschaltbar)</li>
              <li><strong>Items bearbeiten:</strong> Name und Menge direkt ändern mit Auto-Kategorisierung</li>
            </ul>
          </div>

          {/* Improvements */}
          <div style={{ marginBottom: '0' }}>
            <h3 style={{ 
              color: 'var(--info)', 
              fontSize: '1rem', 
              fontWeight: '600', 
              marginBottom: '0.75rem'
            }}>
              Verbessert
            </h3>
            <ul style={{ 
              margin: 0, 
              paddingLeft: '1.5rem',
              color: 'var(--text-primary)',
              lineHeight: '1.8'
            }}>
              <li>Dreipunkte-Menü (⋮) für mehr Funktionen pro Item</li>
              <li>Kategorie-Icons erscheinen sofort nach Item-Erstellung</li>
              <li>Items ohne Kategorie zeigen graues Tag-Icon zum Hinzufügen</li>
            </ul>
          </div>
        </div>

        {/* Version 1.0.2 */}
        <div style={{
          backgroundColor: 'var(--bg-secondary)',
          borderRadius: '0.75rem',
          padding: '1.5rem',
          marginBottom: '1.5rem',
          border: '1px solid var(--border-color)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginBottom: '1rem'
          }}>
            <span style={{
              backgroundColor: 'var(--primary)',
              color: 'white',
              padding: '0.25rem 0.75rem',
              borderRadius: '1rem',
              fontSize: '0.875rem',
              fontWeight: '600'
            }}>
              v1.0.2 - dev1
            </span>
            <span style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
              6. Februar 2026
            </span>
          </div>

          {/* New Features */}
          <div style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ 
              color: 'var(--success)', 
              fontSize: '1rem', 
              fontWeight: '600', 
              marginBottom: '0.75rem'
            }}>
              Neu
            </h3>
            <ul style={{ 
              margin: 0, 
              paddingLeft: '1.5rem',
              color: 'var(--text-primary)',
              lineHeight: '1.8'
            }}>
              <li>Listen können jetzt umbenannt werden</li>
              <li>Individuelle Farben für jede Liste zur besseren Übersicht</li>
              <li>Listen lassen sich per Drag and Drop sortieren</li>
              <li>Vibrationsfeedback beim Verschieben von Listen auf dem Smartphone</li>
            </ul>
          </div>

          {/* Improvements */}
          <div style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ 
              color: 'var(--warning)', 
              fontSize: '1rem', 
              fontWeight: '600', 
              marginBottom: '0.75rem'
            }}>
              Verbessert
            </h3>
            <ul style={{ 
              margin: 0, 
              paddingLeft: '1.5rem',
              color: 'var(--text-primary)',
              lineHeight: '1.8'
            }}>
              <li>Menü für Listen-Aktionen ist jetzt besser für Touch-Bedienung geeignet</li>
              <li>Alle Schaltflächen haben eine komfortable Mindestgröße für Mobile</li>
              <li>Statusleiste wird auf Android korrekt angezeigt</li>
            </ul>
          </div>

          {/* Technical */}
          <div>
            <h3 style={{ 
              color: 'var(--text-secondary)', 
              fontSize: '1rem', 
              fontWeight: '600', 
              marginBottom: '0.75rem'
            }}>
              Technisch
            </h3>
            <ul style={{ 
              margin: 0, 
              paddingLeft: '1.5rem',
              color: 'var(--text-primary)',
              lineHeight: '1.8'
            }}>
              <li>Aktualisierung für Android 15 Kompatibilität</li>
            </ul>
          </div>
        </div>

        {/* Version 1.0.1 */}
        <div style={{
          backgroundColor: 'var(--bg-secondary)',
          borderRadius: '0.75rem',
          padding: '1.5rem',
          marginBottom: '1.5rem',
          border: '1px solid var(--border-color)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginBottom: '1rem'
          }}>
            <span style={{
              backgroundColor: 'var(--text-secondary)',
              color: 'white',
              padding: '0.25rem 0.75rem',
              borderRadius: '1rem',
              fontSize: '0.875rem',
              fontWeight: '600'
            }}>
              v1.0.1-4
            </span>
            <span style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
              4. Februar 2026
            </span>
          </div>

          {/* Changed Section */}
          <div style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ 
              color: 'var(--warning)', 
              fontSize: '1rem', 
              fontWeight: '600', 
              marginBottom: '0.75rem'
            }}>
              Geändert
            </h3>
            <ul style={{ 
              margin: 0, 
              paddingLeft: '1.5rem',
              color: 'var(--text-primary)',
              lineHeight: '1.8'
            }}>
              <li>Input-Felder werden sofort geleert, nicht erst nach Backend-Response</li>
              <li>Kleinerer, kompakterer Offline-Indikator</li>
              <li>Push-Token Backend nutzt jetzt atomares upsert (verhindert Race Conditions)</li>
              <li>Verbesserte Error-Handler bei Offline-Operationen</li>
            </ul>
          </div>

          {/* Fixed Section */}
          <div>
            <h3 style={{ 
              color: 'var(--danger)', 
              fontSize: '1rem', 
              fontWeight: '600', 
              marginBottom: '0.75rem'
            }}>
              Behoben
            </h3>
            <ul style={{ 
              margin: 0, 
              paddingLeft: '1.5rem',
              color: 'var(--text-primary)',
              lineHeight: '1.8'
            }}>
              <li>Items verschwinden nicht mehr beim Reconnect nach Offline-Nutzung</li>
              <li>Push-Token werden nach Login korrekt registriert</li>
              <li>Race Condition bei gleichzeitiger Push-Token-Registrierung behoben</li>
              <li>Offline-Queue wird nach erfolgreichem Sync korrekt geleert</li>
            </ul>
          </div>
        </div>

        {/* Version 1.0.0 */}
        <div style={{
          backgroundColor: 'var(--bg-secondary)',
          borderRadius: '0.75rem',
          padding: '1.5rem',
          marginBottom: '1.5rem',
          border: '1px solid var(--border-color)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginBottom: '1rem'
          }}>
            <span style={{
              backgroundColor: 'var(--text-secondary)',
              color: 'white',
              padding: '0.25rem 0.75rem',
              borderRadius: '1rem',
              fontSize: '0.875rem',
              fontWeight: '600'
            }}>
              v1.0.0
            </span>
            <span style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
              3. Februar 2026
            </span>
          </div>

          {/* Added Section */}
          <div style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ 
              color: 'var(--success)', 
              fontSize: '1rem', 
              fontWeight: '600', 
              marginBottom: '0.75rem'
            }}>
              Hinzugefügt
            </h3>
            <ul style={{ 
              margin: 0, 
              paddingLeft: '1.5rem',
              color: 'var(--text-primary)',
              lineHeight: '1.8'
            }}>
              <li><strong>Link-Erkennung</strong> - URLs in Listenelementen werden automatisch erkannt und anklickbar gemacht</li>
              <li><strong>Link-Vorschau</strong> - WhatsApp-ähnliche Vorschau mit Titel, Beschreibung, Bild und Favicon</li>
              <li><strong>Browser-Integration</strong> - Links öffnen im nativen Android Browser</li>
              <li><strong>2-Faktor-Authentifizierung</strong> - Zusätzliche Sicherheit mit TOTP (Google Authenticator, etc.)</li>
              <li><strong>Push-Benachrichtigungen</strong> - Bleibe über Änderungen in deinen Listen informiert</li>
              <li><strong>Echtzeit-Synchronisation</strong> - Änderungen erscheinen sofort bei allen Nutzern</li>
              <li><strong>Offline-Unterstützung</strong> - Arbeite auch ohne Internetverbindung</li>
              <li><strong>Live-Cursors</strong> - Siehe wo andere Nutzer gerade tippen</li>
              <li><strong>Dark Mode</strong> - Schone deine Augen bei Nacht</li>
              <li><strong>PWA & Android App</strong> - Installierbar auf allen Geräten</li>
              <li><strong>Listen teilen</strong> - Lade andere per E-Mail ein</li>
            </ul>
          </div>

          {/* Changed Section */}
          <div style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ 
              color: 'var(--warning)', 
              fontSize: '1rem', 
              fontWeight: '600', 
              marginBottom: '0.75rem'
            }}>
              Geändert
            </h3>
            <ul style={{ 
              margin: 0, 
              paddingLeft: '1.5rem',
              color: 'var(--text-primary)',
              lineHeight: '1.8'
            }}>
              <li>Verbesserte Socket-Reconnection bei App-Resume (1s Delay, saubere Neu-Verbindung)</li>
              <li>Push-Token werden jetzt beim Logout korrekt vom Backend entfernt</li>
            </ul>
          </div>

          {/* Fixed Section */}
          <div>
            <h3 style={{ 
              color: 'var(--danger)', 
              fontSize: '1rem', 
              fontWeight: '600', 
              marginBottom: '0.75rem'
            }}>
              Behoben
            </h3>
            <ul style={{ 
              margin: 0, 
              paddingLeft: '1.5rem',
              color: 'var(--text-primary)',
              lineHeight: '1.8'
            }}>
              <li>App-State-Listener Konflikte zwischen useCapacitor und SocketContext behoben</li>
              <li>Push-Token Management verbessert - gerätespezifische Tokens</li>
            </ul>
          </div>
        </div>

        {/* Info Box */}
        <div style={{
          backgroundColor: 'var(--bg-info)',
          border: '1px solid var(--border-info)',
          borderRadius: '0.5rem',
          padding: '1rem',
          color: 'var(--text-primary)',
          fontSize: '0.875rem',
          lineHeight: '1.6'
        }}>
          <strong>💡 Hinweis:</strong> Dies ist die erste offizielle Version von MeineListen. 
          Feedback und Fehlerberichte sind herzlich willkommen!
        </div>
      </div>
    </div>
  );
}
